/**
 * BRAND CONFIGURATION — Fundle (Staging)
 * ============================================
 *
 * This is a STAGING/QA instance of the Fundle engine. Identity is
 * intentionally generic "Fundle" — NOT a customer brand — so the same
 * instance can be used to (a) exercise every platform feature end-to-end
 * and (b) test the APIs of multiple POS vendors before wiring them to
 * production.
 *
 * The colour palette + `--kazo-*` CSS variables are retained (they are
 * stable selectors used across 50+ components); only the display strings
 * change to the neutral Fundle identity.
 */

const APP_ENV = process.env.REACT_APP_APP_ENV || "staging";
const IS_STAGING = APP_ENV === "staging";

export const BRAND = {
  // -- Environment ----------------------------------------------------
  appEnv: APP_ENV,
  isStaging: IS_STAGING,

  // -- Identity --------------------------------------------------------
  name: "Fundle",
  legalName: "Fundle",
  domain: "staging.fundlebrain.ai",
  shortDescriptor: "loyalty, CRM, analytics and campaign automation engine",

  // -- Platform identity (the engine)
  platform: "Fundle",
  poweredBy: "Powered by Fundle",
  aiAssistant: "Fundle Brain",
  platformLogoUrl: "/fundle-logo.png",

  // -- Loyalty programme branding -------------------------------------
  loyaltyProgramName: "Fundle Rewards",
  welcomePointsValue: 100,
  welcomeToast: "Welcome to Fundle Rewards! 100 bonus points credited.",
  ctaJoinFree: "Join Fundle Rewards",

  // -- Social (staging placeholders) ----------------------------------
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    youtube: "https://youtube.com",
  },

  // -- SEO / meta -----------------------------------------------------
  meta: {
    title: IS_STAGING
      ? "[STAGING] Fundle — Loyalty · CRM · Analytics"
      : "Fundle — Loyalty · CRM · Analytics",
    description:
      "Fundle staging instance — internal QA + multi-POS vendor API sandbox for the Fundle loyalty, CRM, analytics and campaign automation platform.",
  },

  // -- Public home copy ----------------------------------------------
  homeCopy: {
    heroEyebrow: "Fundle · Staging",
    heroSubtext:
      "This is the Fundle staging environment — an internal QA + multi-POS vendor API test harness for the Fundle loyalty, CRM, analytics and campaign automation engine.",
    heroImageAlt: "Fundle loyalty and CRM platform",
    boutiqueImageAlt: "Fundle store view",
    editorialImageAlt: "Fundle rewards experience",
  },

  // -- Footer copy ---------------------------------------------------
  footerTagline:
    "Fundle — the enterprise loyalty, CRM, analytics and campaign engine. Staging environment for internal QA and multi-POS API testing.",

  // -- Login / portal copy -------------------------------------------
  loginCopy: {
    descriptor:
      IS_STAGING
        ? "Fundle Staging — internal QA + multi-POS vendor API sandbox."
        : "A unified suite for loyalty, CRM, analytics and campaigns.",
    imageAlt: "Fundle",
  },

  // -- Brand colour palette ------------------------------------------
  // Keep variable NAMES + CSS class names intact per spec §1 — the app is
  // NOT being restyled for a customer brand. Values reused from the base.
  colors: {
    black: "#0A0A0A",
    cream: "#F9F8F6",
    burgundy: "#571326",
    burgundyDeep: "#3B0D1B",
    champagne: "#C7A76D",
    champagneLight: "#E0CFA3",
  },
};

export default BRAND;
